<template>
  <!-- Sin sesión y en móvil no hay nada que enseñar: no pintamos ni el div, o
       el `gap` del app bar dejaría un hueco de 8px por un elemento vacío. -->
  <user-button v-if="isLoggedIn"></user-button>
  <button v-else-if="!$vuetify.breakpoint.xs" type="button" class="login-button" @click="goToSignIn()">
    {{ $t('nav.signIn') }}
  </button>
</template>

<script>
import UserButton from './UserButton';
import { resolveSessionUser, logout, clearSessionCookies } from '@/services/nukliApi';

export default {
  components: { UserButton },
  computed: {
    // Mismo criterio que UserButton: hace falta el objeto de usuario, no solo el
    // token. Con `isAuthenticated` a secas se renderizaba el avatar y el propio
    // UserButton se ocultaba por dentro (su v-if mira al usuario), y el app bar
    // se quedaba sin avatar y sin botón de entrar.
    isLoggedIn() {
      return !!resolveSessionUser(this.$root);
    },
  },
  methods: {
    goToSignIn() {
      this.$router.push('/login');
    },
    async signOut() {
      await logout();
      clearSessionCookies(this.$cookies);
      this.$root.nukliUser = null;
      if (this.$route.path !== '/') await this.$router.push('/');
    },
  },
};
</script>

<style scoped>
/* Mismo lenguaje que lp-btn--ghost, a la altura del .nav-cta (38px). */
.login-button {
  height: 38px;
  padding: 0 14px;
  border-radius: 9px;
  border: 1px solid var(--lp-line-strong);
  background: transparent;
  cursor: pointer;
  font-family: 'Space Grotesk', sans-serif;
  font-size: 0.9rem;
  font-weight: 500;
  color: var(--lp-ink);
  transition: background 0.15s ease, border-color 0.15s ease;
}
.login-button:hover {
  background: var(--lp-bg-subtle);
  border-color: var(--lp-ink);
}
</style>
